import * as i18n from "../../i18n.ts";
import * as Html from "../../util/Html.ts";
import * as CustomInput from "../../util/CustomInput.ts";
import * as modal from "../../util/modal.ts";
import * as amplify from "../../util/amplify.ts";
import { markInvalidNative } from "../../util/forms.ts";

import ApiServer from "../../ApiServer.ts";
import {getCache} from "../../server/objects/BudgetBeans.ts";

Html.registerDom({
  transactionaddmoreinfo(){
    const form = this.closest('form');
    const moreinfo = form?.querySelector('.moreinfo') as HTMLElement;
    if (moreinfo) moreinfo.style.display = '';
    Html.fadeOut(this);
  }
})

function initDom(formEl: HTMLElement){
  const form = formEl as HTMLFormElement;
  var
    budgetTransactionType = form.querySelector<HTMLInputElement>('[name=budgetTransactionType]'),
    categorySelect = form.querySelector<HTMLSelectElement>('select[name=budgetCategoryId]'),
    budgetpaidbylabel = form.querySelector<HTMLElement>('.budgetpaidbylabel'),
    catSelectedId = {EXPENSE:categorySelect.getAttribute('data-fw-select-value'),REVENUE:categorySelect.getAttribute('data-fw-select-value')};
  
  function updateUI(){
    var
      currentType = budgetTransactionType.value,
      categories = getCache().budgetCategoryCache.filtered().filter(cat=>cat.budgetTransactionType===currentType),
      defaultCat  = categories.find(cat=>cat.default);

    categorySelect.innerHTML = categories.map(cat=>'<option value="'+cat.metaId+'">'+Html.escape(cat.emoji+' '+cat.name)+'</option>').join('')+'<option value="add">⚙️ '+Html.escape(i18n.get('budget.actions.category'))+'</option>';
    budgetpaidbylabel.innerHTML = i18n.get(currentType==='EXPENSE'?'budget.label.paidby':'budget.label.receivedby');

    if(!categories.find(cat=>cat.metaId===catSelectedId[currentType])){
      catSelectedId[currentType] = defaultCat.metaId;
    }
    categorySelect.value = catSelectedId[currentType];
  }
  categorySelect.addEventListener('change',(event)=>{
     var
      currentType = budgetTransactionType.value;
    if(categorySelect.value==='add'){
      categorySelect.value = catSelectedId[currentType];
      Html.trigger(categorySelect,'budgetcategorymanage',[budgetTransactionType.value])
    }else{
      catSelectedId[currentType] = categorySelect.value;
    }
  })
  updateUI();
  //radio must be enable
  setTimeout(function(){
    budgetTransactionType.addEventListener('change',updateUI);
  },1)
  amplify.subscribe('budgetRefreshed',updateUI);

  form.addEventListener('submit', async function(event){
    event.preventDefault();
    event.stopImmediatePropagation();
    event.stopPropagation();

    const amountInput = form.amount as HTMLInputElement;
    if(CustomInput.getAmountValue(amountInput)==0){
      markInvalidNative(amountInput, i18n.get('budget.transactionerrors.amount'));
      amountInput.select();
      return;
    }

    var
      metaId = form.metaId ? form.metaId.value:null,
      mode :string;

    function doit(option){
      ApiServer.budgettransactionput.prepare(option)(form,function(){},async function(err){
        if(err.code==='502' && err.message.indexOf('non-recurrent budget')>-1){
          await modal.alert({
            title:'communication.justonemorething',
            message:"fw2.apierrors.502transactionrecurrencyend"
          })
          const recurrencyEnd = document.querySelector<HTMLElement>('*[data-widget="widget/form/recurrencyend"]');
          if (recurrencyEnd) recurrencyEnd.click();
        }else{
          throw err;
        }
      })
    }
    if(metaId){
      var
        allMode = await ApiServer.budgettransactionupdateoption(form);
      if(allMode.length<2){
        mode = allMode[0]
      }else{
        mode = await modal.askAsPromise({
          title:'budget.updaterecurringtitle',
          message:'budget.updaterecurringtext',
          button:allMode.map(opt=>{return {value:opt,title:'budget.updaterecurring'+opt}})
        })
      }
      if(mode){
        doit(mode);
      }

    }else{
      doit(null);
    }


  })

}
Html.registerWidget('widget/form/budgetTransactionForm',{initDom})
